module.exports = "/_next/static/images/2f14998451d931f099c189543bdeb6a3-savings-waitlist-promise-3b-lg-2x.jpg.webp";